import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/Main';
import injectTapEventPlugin from 'react-tap-event-plugin';
import register from './sw-register.js';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

// ServiceWorker
register();

// Render the main component into the dom
ReactDOM.render(<App />, document.getElementById('app'));

window.Perf = require('react-addons-perf');



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/